import React, { useState } from 'react'
import { Plus } from 'lucide-react'

// LIST MISI
import MissionsDaily from './MissionsDaily'
import MissionsWeekly from './MissionsWeekly'

// FORM INPUT MISI
import MissionForm from './MissionForm'

export default function MissionsPage() {
  const [tab, setTab] = useState('daily') // daily | weekly
  const [openForm, setOpenForm] = useState(false)

  return (
    <div className="text-white">
      {/* HEADER */}
      <div className="flex items-center justify-between mb-5">
        <h2 className="text-xl font-semibold text-blue-400">
          🎯 Manajemen Misi Mitra
        </h2>

        <button
          onClick={() => setOpenForm(true)}
          className="flex items-center gap-2 px-4 py-2 rounded bg-green-600 hover:bg-green-700 text-sm"
        >
          <Plus size={16} /> Tambah Misi
        </button>
      </div>

      {/* TAB SWITCH */}
      <div className="flex gap-2 mb-6">
        <button
          onClick={() => setTab('daily')}
          className={`px-4 py-2 rounded text-sm transition ${
            tab === 'daily'
              ? 'bg-blue-600 text-white'
              : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
          }`}
        >
          Misi Harian
        </button>

        <button
          onClick={() => setTab('weekly')}
          className={`px-4 py-2 rounded text-sm transition ${
            tab === 'weekly'
              ? 'bg-blue-600 text-white'
              : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
          }`}
        >
          Misi Mingguan
        </button>
      </div>

      {/* FORM INPUT MISI */}
      {openForm && (
        <MissionForm
          scope={tab} // ⬅️ otomatis harian / mingguan
          onClose={() => setOpenForm(false)}
        />
      )}

      {/* LIST MISI */}
      <div className="mt-4">
        {tab === 'daily' && <MissionsDaily />}
        {tab === 'weekly' && <MissionsWeekly />}
      </div>
    </div>
  )
}
